import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from './Header';
import { SocialLinks } from './SocialLinks';
import { MOTTO } from '../config/brand';

export const COMPLIANCE_LINKS = [
    { to: '/learn', key: 'learn', label: 'Free Lesson' },
    { to: '/about-us', key: 'about', label: 'About Us' },
    { to: '/contact-us', key: 'contact', label: 'Contact' },
    { to: '/disclaimer', key: 'disclaimer', label: 'Disclaimer' },
];

export const EDU_DISCLAIMER =
    'Educational Disclaimer: Nikayo FX Guide provides educational content only. Forex & CFD trading involves substantial risk of loss. We do not provide financial advice, investment advice, or guaranteed signals. Past performance is not indicative of future results. 18+ only.';

export function ComplianceLinks({ dark = true, className = '' }) {
    const { t } = useTranslation();
    return (
        <nav className={`flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold ${className}`} data-testid="compliance-links">
            {COMPLIANCE_LINKS.map((l) => (
                <Link key={l.key} to={l.to} className={`${dark ? 'text-zinc-400 hover:text-[#FFB800]' : 'hover:underline'} transition-colors`}
                    style={dark ? undefined : { color: 'var(--text-secondary)' }} data-testid={`compliance-link-${l.key}`}>
                    {t(`compliance.${l.key}`, l.label)}
                </Link>
            ))}
        </nav>
    );
}

export function EduDisclaimer({ dark = true }) {
    const { t } = useTranslation();
    return (
        <p className={`text-xs leading-relaxed text-center max-w-3xl mx-auto ${dark ? 'text-zinc-500' : ''}`}
            style={dark ? undefined : { color: 'var(--text-muted)' }} data-testid="edu-disclaimer">
            {t('compliance.eduDisclaimer', EDU_DISCLAIMER)}
        </p>
    );
}

export default function PublicShell({ title, eyebrow, children, testId }) {
    const { t } = useTranslation();
    return (
        <div className="min-h-screen bg-[#050505] text-white" data-testid={testId}>
            <Header gold />
            <main className="max-w-4xl mx-auto px-4 sm:px-6 pt-16 pb-24">
                {eyebrow && <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#FFB800] mb-4">{eyebrow}</p>}
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mb-10" style={{ fontFamily: "'Outfit', sans-serif" }}>{title}</h1>
                <div className="prose-nikayo space-y-5 text-base text-zinc-300 leading-relaxed">{children}</div>
            </main>
            <footer className="py-12 border-t border-zinc-900" data-testid="public-footer">
                <div className="max-w-5xl mx-auto px-4 space-y-5">
                    <p className="text-center text-sm italic font-semibold tracking-[0.15em]" style={{ fontFamily: "'Playfair Display', serif", color: '#FFB800' }}>“{MOTTO}”</p>
                    <ComplianceLinks />
                    <EduDisclaimer />
                    <SocialLinks />
                    <p className="text-sm text-center text-zinc-600">© {new Date().getFullYear()} NIKAYO FX GUIDE. {t('landing.footer.copyright')}</p>
                </div>
            </footer>
        </div>
    );
}
